<template>
    <main-content with_go_back_bar>
        <kt-panel>
            <kt-panel-body>
                <question-form :submit="update"></question-form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import { mapGetters } from "vuex";
import { KTApp } from "@/plugins/core/app"
import $ from 'jquery'
import questionForm from './components/question-form'
import { i18n } from '@/plugins/i18n'
import {knowledgeManagementService} from "../../common/api.service";


export default {
    components: {
        mainContent,
        questionForm
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters('KnowledgeManagement', [
            'questionForm'
        ])
    },
    methods: {
        update(e) {
            let form = $(e.target)
            let btn = $('#submit-btn')

            KTApp.progress(btn)

            let params = {
                title: this.questionForm.title,
                question: this.questionForm.question,
                answer: this.questionForm.answer,
                cat_id: this.questionForm.cat_id
            }

            knowledgeManagementService.updateQuestion(this.$route.params.hashid, params)
                .then(response => {
                    this.$router.push('/knowledge-categories/' + this.questionForm.cat_id + '/details#questions')
                })
                .catch(({response}) => {
                    if(response.data) {
                        form.validate().showErrors(response.data.data)
                        this.showMsg(form, 'danger', response.data.message)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        }
    },
    mounted() {
        this.$store.dispatch('KnowledgeManagement/findQuestion', this.$route.params.hashid)
    }
}
</script>

<style >

</style>